import biabimoozimLogo from "../../../image/home/companions/biabiamoozim-logo.png";
import elazadLogo from "../../../image/home/companions/elazad-logo.png";
import mardomLogo from "../../../image/home/companions/mardom-logo.png";
import noronLogo from "../../../image/home/companions/noron-logo.png";
import raziShoolLogo from "../../../image/home/companions/razi-shool-logo.png";
import sadrShoolLogo from "../../../image/home/companions/sadr-shool-logo.png";

export const companionsData = [
  {
    id: 1,
    title: "جامعه یاوری فرهنگی",
    img: biabimoozimLogo,
    alt: "",
    href: "https://school.yavari.ir",
  },
  {
    id: 2,
    title: "مرکز رشد واحد الکترونیکی",
    img: elazadLogo,
    alt: "",
    href: "https://roshd.iauec.ac.ir",
  },
  {
    id: 3,
    title: "موسسه رشد دانش‌آموزان مناطق محروم «مردم»",
    img: mardomLogo,
    alt: "",
    href: "https://mardomm.ir",
  },
  {
    id: 4,
    title: "موسسه نورون سیستم",
    img: noronLogo,
    alt: "",
    href: "https://noronapp.ir",
  },
  {
    id: 5,
    title: "مجتمع آموزشی شایستگان رازی",
    img: raziShoolLogo,
    alt: "",
    href: "https://www.razy.sch.ir/",
  },
  {
    id: 6,
    title: "دبیرستان نمونه دولتی امام موسی صدر",
    img: sadrShoolLogo,
    alt: "",
    href: "https://www.emsadrhs1.ir",
  },
];
